;(function cartFiller() {
    function cartFiller() {
        /**
         * local cartFiller
         * @private
         */
        var _this = this

        /**
         * config
         */
        this.config = {}

        /**
         * initialize
         * @return {undefined}
         */
        this.init = function () {
            _this.config = window.Creaton.Cart.Configuration
            _this.bindCartItems()
            _this.submitForm()
        }

        /**
         * bind single product items
         * @return {undefined}
         */
        this.bindCartItems = function () {
            _this.config.$cartModal.on('shown.bs.modal', function (e) {
                $(_this.config.cartItem+":not(.not-available)").bind('click', function () {
                    _this.updateItem(this)
                })
            })
        }

        /**
         * update local storage
         * @return {undefined}
         */
        this.pushCartItems = function () {
            localStorage.setItem(_this.config.cart, JSON.stringify(_this.config.cartItems))
            $(document).trigger(_this.config.cartEventListener)
        }

        /**
         * add or remove item form temp cart object
         * @return {undefined}
         */
        this.updateItem = function (item) {
            if ($(item).hasClass('active')) {
                _this.removeItem(item)
            } else {
                _this.addItem(item)
            }
            _this.pushCartItems();
        }

        /**
         * remove item to temp cart object
         * @return {undefined}
         */
        this.removeItem = function (item) {
            delete _this.config.cartItems[$(item).data('order-code')]
            $(item).removeClass('active')
        }

        /**
         * add item to temp cart object
         * @return {undefined}
         */
        this.addItem = function (item) {
            var itemJson = {
                'product-title': $(item).data('product-title'),
                'product-category': $(item).data('product-category'),
                'product-country': $(item).data('product-country'),
                'color-title': $(item).data('color-title'),
                'color-identifier': $(item).data('color-identifier'),
                'image-uri': $(item).data('image-uri'),
                link: $(item).data('link'),
                amount: 1,
            }
            _this.config.cartItems[$(item).data('order-code')] = itemJson
            $(item).addClass('active')
        }

        /**
         *  Check if order form is submitted and remove the cart
         */
        this.submitForm = function () {
            _this.config.$sampleOrderForm.submit(function () {})
        }

        _this.init()
    }

    // define the global scope
    if (!window.Creaton) {
        window.Creaton = {}
    }
    window.Creaton.cartFiller = cartFiller
})()
